import api from './api';

const faqService = {
  async getAll() {
    const response = await api.get('/faq');
    return response.data;
  },

  async create(data) {
    const response = await api.post('/faq', data);
    return response.data;
  },

  async update(id, data) {
    const response = await api.patch(`/faq/${id}`, data);
    return response.data;
  },

  async remove(id) {
    const response = await api.delete(`/faq/${id}`);
    return response.data;
  },
};

export default faqService;
